/* CUSTOM (Carver/Loaded shared): mega-menu deferred image hydration.
   Menu images render with data-nav-src/data-nav-srcset (no src), so they cost
   nothing on initial page load. They hydrate:
     1. instantly on first hover/touch/focus of their nav item (before the
        dropdown's opening transition finishes), and
     2. as a staggered low-priority background warm-up after window load, so
        images are already cached when the user browses the menu.
   Country-selector flags use data-flag-src and hydrate ONLY on interaction
   with their dropdown (118 third-party flag images should never preload).
   On Save-Data or 2G connections the warm-up is skipped entirely. */

(function () {
  'use strict';

  function hydrate(root, attr) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img[' + attr + ']');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      /* the closed dropdown may not intersect the viewport, where
         loading="lazy" would defer the fetch forever — force it */
      img.loading = 'eager';
      var srcset = img.getAttribute(attr + 'set');
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute(attr + 'set');
      }
      img.setAttribute('src', img.getAttribute(attr));
      img.removeAttribute(attr);
    }
  }

  /* --- 1. Hydrate on intent (mouse, touch, keyboard) --- */
  function onIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var navItem = t.closest('.\\#main-nav-item, .\\#main-nav-mobile');
    if (navItem) hydrate(navItem, 'data-nav-src');
    var loc = t.closest('.\\#localization-dropdown, .\\#footer-localization-item');
    if (loc) hydrate(loc, 'data-flag-src');
  }
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
  document.addEventListener('click', onIntent, { passive: true });

  /* --- 2. Background warm-up (menu images only, never flags) --- */
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|[^3-9])2g/.test(conn.effectiveType || ''))) return;

  function warmUp() {
    var scopes = document.querySelectorAll('.\\#main-nav-dropdown, .\\#main-nav-mobile');
    var i = 0;
    (function next() {
      if (i >= scopes.length) return;
      var imgs = scopes[i].querySelectorAll('img[data-nav-src]');
      for (var j = 0; j < imgs.length; j++) {
        if ('fetchPriority' in imgs[j]) imgs[j].fetchPriority = 'low';
      }
      hydrate(scopes[i], 'data-nav-src');
      i++;
      setTimeout(next, 350);
    })();
  }

  function schedule() {
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 2500); };
    idle(warmUp, { timeout: 10000 });
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();
